module.exports = "<h2 mat-dialog-title>{{data.variableDescription}}</h2>\n<mat-dialog-content>\n  <app-charts [unit]=\"data.unit\" [variable]=\"data.variable\" [selectedPeriod]=\"data.period\" [selectedLatlng]=\"data.latlng\"></app-charts>\n</mat-dialog-content>\n<mat-dialog-actions align=\"end\">\n  <button mat-button mat-dialog-close>Close</button>\n</mat-dialog-actions>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialog/dialog.component.html
// module id = ./src/app/dialog/dialog.component.html
// module chunks = main